module.exports = __webpack_public_path__ + "static/media/fa-solid-900.7a8b4f13.svg";